"use client";

import { useId } from "react";
import { Switch } from "@/components/ui/switch";

export default function DemoSwitch({
  checked,
  label,
  onCheckedChange,
}: {
  checked: boolean;
  label: string;
  onCheckedChange: (checked: boolean) => void;
}) {
  const id = useId();

  return (
    <div className="flex items-center gap-2.5">
      <Switch checked={checked} id={id} onCheckedChange={onCheckedChange} />
      <label
        className="cursor-pointer select-none text-gray-1100 text-sm"
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
}
